'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

exports.default = function (config) {
  return function (value) {
    if (value === '') {
      return null;
    }

    var isValid = void 0;

    switch (_typeof(config.value)) {
      case 'number':
        {
          isValid = Number(value) === config.value;
          break;
        }

      case 'boolean':
        {
          isValid = config.value ? value === 'true' : value === 'false';
          break;
        }

      case 'string':
      default:
        {
          isValid = String(value) === config.value;
        }
    }

    return isValid ? null : config.message;
  };
};